import Icon from '../components/Icon';

const VerifiedFilled = Icon(
  'verified-filled',
  <>
    <path
      fillRule="evenodd"
      d="M12 1.255a4 4 0 0 0-3.552 2.16 3.999 3.999 0 0 0-5.034 5.029 3.999 3.999 0 0 0 .004 7.115 3.999 3.999 0 0 0 5.028 5.022 3.999 3.999 0 0 0 7.107.004 4 4 0 0 0 5.034-5.028 3.999 3.999 0 0 0-.004-7.116 4 4 0 0 0-5.028-5.022A4 4 0 0 0 12 1.255m4.471 8.55a.667.667 0 1 0-.943-.943l-4.861 4.862-2.196-2.195a.667.667 0 0 0-.942.943l2.666 2.666c.26.26.683.26.943 0z"
      clipRule="evenodd"
    />
  </>
);

export default VerifiedFilled;
